<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="450">
      <v-card class="pa-4" v-if="Object.keys(detail).length > 0">
        <v-card-title class="body-2 pb-5">
          {{ detail.logNotification.title }}
        </v-card-title>
        <v-card-subtitle class="caption pb-3">
          {{ detail.logDatetime | datetime }}
        </v-card-subtitle>
        <v-card-text class="body-2 font-weight-light pb-3" v-html="convert(detail.logNotification.body)">
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            rounded
            small
            width="70"
            color="#F5F5F5"
            elevation="0"
            light
            class="text-capitalize"
            @click="dialog = false">
            Tutup
          </v-btn>
          <v-btn
            rounded
            small
            width="120" 
            color="#FF618A"
            elevation="0"
            class="white--text text-capitalize"
            @click="dialog = false"
            :to="detail.logProductType === 'forum' ? `/marketplace/class/${detail.logProductId}` : `/purchasing/success/${detail.logInvoiceId}`">
            Lihat Produk
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-app-bar 
      app
      elevation="0"
      fixed
      :class="$route.name === 'home' ? 'header' : 'white'">
      <v-container>
        <v-row justify="start">
          <v-col :cols="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 4 : 3" class="d-flex align-center justify-start">
            <v-btn class="ma-2 hidden-md-and-up" 
              :class="$route.name === 'home' ? 'font-header' : 'btn-header'"
              tile 
              large 
              color="#393939" 
              dark
              @click.stop="drawer = !drawer"
              icon>
              <v-icon left>mdi-menu</v-icon>
            </v-btn>
            <router-link to="/" style="width: 80%">
              <v-img
                class="cursor-pointer"
                contain
                width="auto"
                height="35"
                :src="require('../assets/logo/logo.png')">
              </v-img>
            </router-link>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 1 : 7" class="d-flex align-center justify-end hidden-sm-and-down" :class="token ? 'pr-0' : ''">
            <router-link 
              v-for="(item, index) in token ? user.userRoles === 'user' ? menuUser : menu : menu"
              :key="index"
              :to="item.link"
              class="hidden-sm-and-down">
              <v-card-title v-if="!token && item.label === 'Kelas'" :class="$route.name === 'home' ? $route.path === item.link ? 'font-weight-bold font-header pb-0' : 'font-header' : $route.path === item.link ? 'font-weight-bold pb-0' : ''" class="caption menu cursor-pointer" style="color: #005277;">
                Kelas
              </v-card-title>
              <v-card-title v-if="!token && item.label === 'Beranda'" :class="$route.name === 'home' ? $route.path === item.link ? 'font-weight-bold font-header pb-0' : 'font-header' : $route.path === item.link ? 'font-weight-bold pb-0' : ''" class="caption menu cursor-pointer" style="color: #005277;">
                Beranda
              </v-card-title>
              <v-card-title v-if="token && item.label === 'Dashboard'" :class="$route.name === 'home' ? $route.path === item.link ? 'font-weight-bold font-header pb-0' : 'font-header' : $route.path === item.link ? 'font-weight-bold pb-0' : ''" class="caption menu cursor-pointer" style="color: #005277;">
                Dashboard
              </v-card-title>
              <v-card-title v-if="item.label !== 'Kelas' && item.label !== 'Beranda' && item.label !== 'Dashboard'" :class="$route.name === 'home' ? $route.path === item.link ? 'font-weight-bold font-header pb-0' : 'font-header' : $route.path === item.link ? 'font-weight-bold pb-0' : ''" class="caption menu cursor-pointer" style="color: #005277;">
                {{ item.label }}
              </v-card-title>
              <v-divider color="#FF618A" class="mx-2" v-if=" $route.path === item.link" style="border-width: 1px; margin-bottom: 16px;"></v-divider>
            </router-link>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm'  ? 7 : token ? 2 : $vuetify.breakpoint.name === 'md' ? 2 : 1" class="d-flex align-center" :class="$vuetify.breakpoint.name !== 'xs' || $vuetify.breakpoint.name !== 'sm' ? token ? 'pl-0 justify-end' : 'justify-end pr-0' : 'justify-start'">
            <v-menu
              close-on-content-click nudge-width="250" offset-x
              v-if="token">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn 
                    icon
                    :small="$vuetify.breakpoint.name === 'xs' ? true : false"
                    @click="fetchCart()">
                    <v-badge 
                      v-if="cart.total > 0"
                      color="#FF618A"
                      overlap>
                      <span slot="badge" v-if="cart.total >= 10">
                        9+
                      </span>
                      <span slot="badge" v-else>
                        {{ cart.total }}
                      </span>
                      <span slot="default">
                        <v-icon color="#005277">mdi-cart-arrow-down</v-icon>
                      </span>
                    </v-badge>
                    <span slot="default"
                      v-if="cart.total < 1">
                      <v-icon color="#005277">mdi-cart-arrow-down</v-icon>
                    </span>
                  </v-btn>
                </div>
              </template>
              <v-card>
                <v-list rounded class="overflow-y-auto" max-height="400" max-width="300">
                  <v-skeleton-loader
                    class="ma-auto"
                    :loading="process.run"
                    transition="scale-transition"
                    :tile="false"
                    type="list-item-two-line"
                    v-for="(item, index) in process.run ? 10:cart.results" 
                    :key="index">
                    <v-list-item-group>
                      <v-list-item
                        v-if="!process.run && cart.results.length > 0"
                        to="/cart">
                        <v-list-item-content>
                          <v-list-item-title class="body-2">
                            {{ item.cartProductTitle }}
                          </v-list-item-title>
                          <v-list-item-subtitle class="caption mt-1 text-capitalize">
                            {{ item.cartStatus }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-skeleton-loader>
                  <v-list-item
                    v-if="!process.run && cart.results.length < 1">
                    <v-list-item-content>
                      <v-list-item-title class="caption grey--text text-center justify-center">
                        Belum ada Produk
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-divider class="ma-3 mt-0 mb-0"/>
                <v-card-actions>
                  <v-btn
                    block
                    rounded
                    color="#005277"
                    class="text-capitalize caption"
                    text
                    to="/cart">
                    Lihat Semua</v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
            <v-menu
              close-on-content-click nudge-width="250" offset-x
              v-if="token">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn 
                    icon
                    :small="$vuetify.breakpoint.name === 'xs' ? true : false"
                    @click="fetchNotification()">
                    <v-badge
                      v-if="count > 0"
                      color="#FF618A"
                      overlap>
                      <span slot="badge" v-if="count >= 10">
                        9+
                      </span>
                      <span slot="badge" v-else>
                        {{ count }}
                      </span>
                      <span slot="default">
                        <v-icon color="#005277">mdi-bell</v-icon>
                      </span>
                    </v-badge>
                    <span slot="default"
                      v-if="count < 1">
                      <v-icon color="#005277">mdi-bell</v-icon>
                    </span>
                  </v-btn>
                </div>
              </template>
              <v-card>
                <v-list rounded class="overflow-y-auto" max-height="400" max-width="300">
                  <v-skeleton-loader
                    class="ma-auto"
                    :loading="process.run"
                    transition="scale-transition"
                    :tile="false"
                    type="list-item-two-line"
                    v-for="(item, index) in process.run ? 10:notification" 
                    :key="index">
                    <v-list-item-group>
                      <v-list-item
                        v-if="!process.run && notification.length > 0"
                        @click="toRead(item)">
                        <v-list-item-avatar>
                          <v-icon :color="item.logStatusOpen === 'yes' ? 'grey' : 'yellow darken-4'">mdi-bell</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="body-2">
                            {{ item.logNotification.title }}
                          </v-list-item-title>
                          <v-list-item-subtitle class="caption mt-1">
                            {{ item.logDatetime | datetime }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-skeleton-loader>
                  <v-list-item
                    v-if="!process.run && notification.length < 1">
                    <v-list-item-content>
                      <v-list-item-title class="caption grey--text text-center justify-center">
                        Belum ada Pemberitahuan
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-divider class="ma-3 mt-0 mb-0"/>
                <v-card-actions>
                  <v-btn
                    block
                    rounded
                    color="#005277"
                    class="text-capitalize caption"
                    text
                    to="/notification">
                    Lihat Semua</v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
            <v-menu
              left
              bottom
              v-if="token">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-list-item class="pr-0 cursor-pointer" :class="$vuetify.breakpoint.name === 'xs' ? 'pl-2' : ''">
                    <v-list-item-avatar class="align-self-start cursor-pointer" :class="$vuetify.breakpoint.name === 'xs' ? '' : 'mr-2'" size="30">
                      <v-img :src="user.userUrlImg"></v-img>
                    </v-list-item-avatar>
                  </v-list-item>
                </div>
              </template>
              <v-list
                width="200" 
                dense>
                <router-link to="/transaction" class="black--text">
                  <v-list-item
                    class="cursor-pointer text-left">
                    <v-list-item-title>
                      Riwayat Transaksi
                    </v-list-item-title>
                  </v-list-item>
                </router-link>
                <v-divider class="ma-0"></v-divider>
                <v-list-item 
                  class="cursor-pointer text-left" @click="logout">
                  <v-list-item-title>
                    Keluar
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-btn 
              rounded 
              small 
              elevation="0"
              class="text-capitalize white--text" 
              color="background-default"
              width="100"
              v-if="!token"
              to="/login">
              <v-icon small class="mr-2">mdi-account-outline</v-icon>
              Masuk
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      fixed
      app
      dark
      temporary
      color="#FF618A">
      <v-list dense>
        <router-link 
          v-for="(item, index) in token ? user.userRoles === 'user' ? menuUser : menu : menu"
          :key="index"
          :to="item.link">
          <v-card-title v-if="token ? item.type === 'private' : item.label !== 'Dashboard'" class="caption text-first menu cursor-pointer text-capitalize white--text">
            {{ item.label }}
          </v-card-title>
        </router-link>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../service/Axios";
  import { TokenService } from "../service/Storage.Service";
  export default {
    data () {
      return {
        dialog: false,
        rightDrawer: false,
        drawer:null,
        cart: {
          total: 0,
          results: []
        },
        menu: [
          {
            label: "Beranda",
            link: "/home",
            type: 'public'
          },
          {
            label: "Dashboard",
            link: "/dashboard",
            type: 'private'
          },
          {
            label: "Kelas",
            link: "/class",
            type: 'public'
          },
          {
            label: "Kursus",
            link: "/marketplace/class",
            type: 'private'
          },
          {
            label: "Library",
            link: "/marketplace/library",
            type: 'private'
          },
          {
            label: "Profil",
            link: "/profil",
            type: 'private'
          }
        ],
        menuUser: [
          {
            label: "Beranda",
            link: "/home",
            type: 'public'
          },
          {
            label: "Kelas",
            link: "/class",
            type: 'public'
          },
          {
            label: "Dashboard",
            link: "/dashboard",
            type: 'private'
          },
          {
            label: "Library",
            link: "/marketplace/library",
            type: 'private'
          }
        ],
        notification: [],
        count: 0,
        detail: {},
        process: {
          run: false
        }
      }
    },   
    computed: {
      user () {
        return this.$store.state.user
      },
      token () {
        return this.$store.state.token
      },
      content () {
        let data = localStorage.getItem('content')
        return !data ? this.$store.state.content.content : JSON.parse(data)
      }
    },
    watch: { 
      '$route' (to, from) { 
        this.fetchCart()
        this.fetchCountNotification()
      } 
    },
    mounted () {
      const debounce = (fn) => {
        let frame;
        return (...params) => {
          if (frame) { 
            cancelAnimationFrame(frame)
          }
          frame = requestAnimationFrame(() => {
            fn(...params)
          })
        } 
      };
      const storeScroll = () => {
        document.documentElement.dataset.scroll = window.scrollY
      }
      document.addEventListener('scroll', debounce(storeScroll), { passive: true })
      storeScroll()

      if (!localStorage.getItem('category')) {
        this.fetchCategory()
      }
      // if (!localStorage.getItem('content')) {
        this.fetchContent()
      // }
      if (this.token) {
        this.fetchCart()
        this.fetchCountNotification()
      }
    },
    methods: { 
      async fetchCategory() {
        await this.$store.dispatch('content/getCategory')
        .then((response) => {
          if (response.code === 200) {
            // set local storage
            localStorage.setItem('category', JSON.stringify(response.data))
          }
        })
      },
      async fetchCart() {
        this.process.run = true
        await get(`users/cart/navbar`).then((response) => {
          let res = response.data
          if (res.code === 200) {
            this.cart = {
              total: res.data.total,
              results: res.data.results
            }
            this.process.run = false
          }
        })
      },
      async fetchContent() {
        await this.$store.dispatch('content/getContent')
        .then((response) => {
          if (response.code === 200) {
            // set local storage
            localStorage.setItem('content', JSON.stringify(response.data))
          }
        })
      },
      async fetchNotification() {
        if (this.token) {
          this.process.run = true
          await get(`users/notif`)
          .then((response) => {
            let res = response.data
            if (res.code === 200) {
              this.notification = res.data
              this.process.run = false
            }
          })
        }
      },
      async fetchCountNotification() {
        if (this.token) {
          await get(`users/notif/count`)
          .then((response) => {
            let res = response.data
            if (res.code === 200) {
              this.count = res.data
            }
          })
        }
      },
      convert(item) {
        return item.replace(/&lt;/g, '<')
      },
      toRead(value) {
        this.detail = value
        put(`users/notif/update/status/${this.detail.id}`, {
          data: {
            status: "yes"
          }
        })
        .then((response) => {
          if (response.data.code === 201) {
            this.fetchCountNotification()
            this.dialog = true
          }
        })
      },
      logout() {
        TokenService.removeToken()
        window.location = '/'
      }
    },
    created () {
      if (process.browser) {
        if ('Notification' in window && 'serviceWorker' in navigator) {
          navigator.serviceWorker.addEventListener('message', event => {
            this.fetchCountNotification() // fetch data real time
          })
        }
      }
    }
  }
</script>

<style scoped>
  .header {
    background-color: transparent !important;
  }
  html:not([data-scroll="0"]) .header {
    background-color: #FFFFFF !important;
  }
  .font-header {
    color: #FFFFFF !important;
  }
  html:not([data-scroll="0"]) .font-header {
    color: #005277 !important;
  }
  .btn-header {
    color: #005277 !important;
  }
</style>